export default {
  personal_info: {
    already_signed_up:
      'Dieser Vorgang ist nicht zulässig, da der Benutzer bereits angemeldet ist.',
    already_have_email:
      'Benutzer existiert bereits, bitte melden Sie sich im Portal an oder verwenden Sie eine andere E-Mail-Adresse',
    oldpassword_mismatch: 'Altes Passwort ist nicht korrekt!',
  },
}
